import module from 'nominas/nomina/module.js'

const schema = {
  idPago: 'number',
  importe: 'number',
  resultados: {
    importe: 'number',
    id: 'number',
    observaciones: '',
  },
}

export class NominasNominaDispersionPagosDividirService {
  constructor ($http) {
    this.$http = $http
  }

  put (idNomina, idProyecto, data) {
    return this.$http.put('/api/nominas/nomina/dispersion/pagos/herramientas/divisor', data, {
      params: {id_nomina: idNomina,id_proyecto: idProyecto},
      schema,
    })
  }
}

module.service('NominasNominaDispersionPagosDividirService', NominasNominaDispersionPagosDividirService)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Dispersion/Pagos/Dividir.js